import Link, { type LinkProps } from "next/link"
import type { ReactNode } from "react"

type DivProps = React.HTMLAttributes<HTMLDivElement>

type MaybeLinkProps<T extends boolean> = {
  href?: string
  children: ReactNode
} & (T extends true ? LinkProps : DivProps)

export function MaybeLink<T extends boolean>({ children, ...props }: MaybeLinkProps<T>) {
  if (props.href) {
    return (
      <Link prefetch={false} {...(props as LinkProps)}>
        {children}
      </Link>
    )
  }
  return <div {...(props as DivProps)}>{children}</div>
}
